import { render, staticRenderFns } from "./modifyBoxRules.vue?vue&type=template&id=497cdf15&scoped=true&"
import script from "./modifyBoxRules.vue?vue&type=script&lang=js&"
export * from "./modifyBoxRules.vue?vue&type=script&lang=js&"
import style0 from "./modifyBoxRules.vue?vue&type=style&index=0&id=497cdf15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497cdf15",
  null
  
)

export default component.exports